// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"474":"1ef75c3c","666":"f218ea91"}[chunkId] + ".chunk.css";
};